import api from './HttpUtil';


export interface iMedios {
    nombre: string,
    codigo: string
}


export interface iColeccion {
    id?: number,
    nombre?: string,
    codigo?: string,
    medios?: iMedios[],
    titulo?: string,
    portada?: string,
    publicar?: number,
    orden?: number,
    usuario_creacion?: number,
    usuario_modificacion?: number,
}

export default {
    getAll(){
        return api.get('/coleccion/all');
    },

    getForWorks(){
        return api.get('/coleccion/forworks');
    },

    getById(id: string){
        return api.get('/coleccion/'+id);
    }
}